module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-side content-side-full"
  }, [_c('ul', {
    staticClass: "nav-main"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "si si-cup"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-basket"
  }), _vm._v(" "), _c('span', [_vm._v("Bestellingen")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'refunds'
      }
    }
  }, [_c('i', {
    staticClass: "si si-control-rewind"
  }), _vm._v(" "), _c('span', [_vm._v("Retouren")])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'unknown_products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), (_vm.amountUnknownProducts) ? _c('span', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-lg text-danger"
  }), _vm._v(" " + _vm._s(_vm.amountUnknownProducts) + " Onbekende producten ")]) : _c('span', [_vm._v("Onbekende producten")])])], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'order_lists'
      }
    }
  }, [_c('i', {
    staticClass: "si si-tag"
  }), _vm._v(" "), _c('span', [_vm._v("Inkooporders")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'users'
      }
    }
  }, [_c('i', {
    staticClass: "si si-people"
  }), _vm._v(" "), _c('span', [_vm._v("Gebruikers")])])], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'sales-channels'
      }
    }
  }, [_c('i', {
    staticClass: "si si-share"
  }), _vm._v(" "), _c('span', [_vm._v("Verkoopkanalen")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dropshipment'
      }
    }
  }, [_c('i', {
    staticClass: "si si-share"
  }), _vm._v(" "), _c('span', [_vm._v("Dropshipment")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wrench"
  }), _vm._v(" "), _c('span', [_vm._v("Instellingen")])])], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_purchasing_value_orders'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Winstgevendheid")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_profit_margins'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Product winstgevendheid")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_revenue'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Omzet")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'report_products'
      }
    }
  }, [_c('i', {
    staticClass: "si si-bar-chart"
  }), _vm._v(" "), _c('span', [_vm._v("Producten")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Orderafhandeling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Magazijn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Inkooporders")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Medewerkers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Systeem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-main-heading"
  }, [_c('span', [_vm._v("Rapportage")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d47a7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/partials/AdminSidebar.vue
// module id = 742
// module chunks = 1